$('#show_service_cost_link').click(function(e) {
  e.preventDefault();

  $('#service_contract_cost_wrapper').toggleClass('hidden');
  var linkText = $('#service_contract_cost_wrapper').hasClass('hidden') ? 'Show cost' : 'Hide cost';
  $(this).text(linkText);
  if (linkText === 'Hide cost') {
    $(this).removeClass('blue-text').addClass('red-text');
  } else {
    $(this).removeClass('red-text').addClass('blue-text');
  }
});

function serviceContractType() {
  const fieldset = document.getElementById('service_contract_fields');
  if (!fieldset) return 'none';

  return fieldset.getAttribute('data-contract-type') || 'none';
}

// Toggle plain fields so the hidden section doesn't submit its values. We
// deliberately leave <select> elements alone: they're enhanced by Choices.js,
// and flipping the native `disabled` attribute leaves the Choices widget stuck
// greyed-out (it tracks its own enabled state). The visible section already
// controls submission via its enabled service_contract_type / _destroy inputs.
function setFieldsEnabled($container, enabled) {
  $container.find('input, textarea').prop('disabled', !enabled);
}

class ServiceContractUI {
  clearFields() {
    $('#deal_service_contract_attributes_selling_price').val(0);
    $('#deal_service_contract_attributes_cost').val(0);
    $('#deal_service_contract_attributes_deductible').val('');
    $('#deal_service_contract_attributes_months').val('');
    $('#deal_service_contract_attributes_miles').val('');
    $('#deal_service_contract_attributes_expiration_date').val('');
    $('#deal_service_contract_attributes_plan_number').val('');
    // `calculate_financing` is a const inside deal.js's turbo:load scope — calling it from here
    // was a ReferenceError, and the payment kept the contract money the dealer had just removed.
    // Ask deal.js to recalculate through the event it owns.
    $(document).trigger('deal:recalculate');
  }
}

class NoneUI extends ServiceContractUI {
  show() {
    $('.no-service-contract-link-block').hide();
    $('#no_service_contract').show();
    setFieldsEnabled($('#no_service_contract'), true);
  }

  hide() {
    $('#no_service_contract').hide();
    $('.no-service-contract-link-block').show();
    this.disable();
  }

  disable() {
    setFieldsEnabled($('#no_service_contract'), false);
  }
}

class BasicUI extends ServiceContractUI {
  show() {
    $('#basic_service_contract').show();
    $('.other-service-contract-link-block').hide();
    setFieldsEnabled($('#basic_service_contract'), true);
  }

  hide() {
    $('#basic_service_contract').hide();
    $('.other-service-contract-link-block').show();
    this.disable();
  }

  disable() {
    setFieldsEnabled($('#basic_service_contract'), false);
  }
}

const noneUI = new NoneUI();
const basicUI = new BasicUI();

function initServiceContractUI() {
  if (!document.getElementById('service_contract_fields')) return;

  $('#deal_type_of_sale_wholesale').off('click.serviceContract').on('click.serviceContract', () => {
    setTimeout(() => {
      $('.no-service-contract-link').click();
      $('#deal_accessories').val('0.00');
    }, 0);
  });

  $('.no-service-contract-link').off('click.serviceContract').on('click.serviceContract', () => {
    noneUI.show();
    basicUI.hide();
    basicUI.clearFields();
  });

  $('.other-service-contract-link').off('click.serviceContract').on('click.serviceContract', () => {
    noneUI.hide();
    basicUI.show();
  });

  if (serviceContractType() === 'basic') {
    noneUI.hide();
    basicUI.show();
  } else {
    basicUI.hide();
    noneUI.show();
  }
}

$(document).ready(initServiceContractUI);
document.addEventListener('turbo:load', initServiceContractUI);
